import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Show,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  DateField,
  required,
  SearchInput,
  DateInput,
  ReferenceArrayField,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  TabbedShowLayout,
  Tab,
  SimpleShowLayout,
  NumberField,
  SelectField,
  UrlField,
  FilterButton,
  CreateButton,
  TopToolbar,
  Button,
} from "react-admin";
import { useNavigate } from "react-router-dom";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import DynamicDropdownFilter from "../components/DynamicDropdownFilter";
import StringArrayField from "../components/StringArrayField";
import { ADJUDICATION_CATEGORY_CHOICES } from "../consts";
import ExportAllButton from "../components/ExportAllButton";

const releaseFilters = [
  <SearchInput source="q_name" alwaysOn />,
  <DynamicDropdownFilter
    label="Product"
    source="name"
    resource="cve/releases"
  />,
  <DynamicDropdownFilter
    label="Release Version"
    source="version"
    resource="cve/releases"
  />,
];

const ListActions = () => {
  const navigate = useNavigate();
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton />
      <ExportAllButton />
      <Button
        label="Compare Releases"
        onClick={() => navigate("/cve/compare-releases")}
      >
        <CompareArrowsIcon />
      </Button>
    </TopToolbar>
  );
};

export const ReleaseList = () => (
  <List filters={releaseFilters} perPage={25} actions={<ListActions />}>
    <Datagrid rowClick="show">
      <TextField label="Product" source="name" />
      <TextField source="version" />
      <DateField source="endOfMaintenanceDate" />
      <DateField source="releaseDate" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);

export const CveRowShow = () => (
  <SimpleShowLayout>
    <TextField source="description" />
    <TextField source="imageRepository" />
    <TextField source="imageTag" />
    <TextField source="availableFixedImageBuildTag" />
    <TextField source="availableFixedReleaseVersion" />
    <NumberField source="companyScore" />
    <NumberField source="cvssScore" />
    <NumberField source="epssScore" />
    <TextField source="vulnerableDependencyName" />
    <TextField source="vulnerableDependencyPackageName" />
    <TextField source="vulnerableDependencyVersion" />
    <StringArrayField source="vulnerableDependencyFixVersions" />
    <StringArrayField source="vulnerableDependencyPaths" />
    <UrlField source="githubIssue" />
    <UrlField source="jiraTicket" />
    <SelectField
      source="adjudicationCategory"
      choices={ADJUDICATION_CATEGORY_CHOICES}
    />
    <TextField source="adjudicationNotes" />
  </SimpleShowLayout>
);

export const ReleaseShow = () => (
  <Show>
    <TabbedShowLayout>
      <Tab label="Release Details">
        <TextField label="Product" source="name" />
        <TextField source="version" />
        <DateField source="endOfMaintenanceDate" />
        <DateField source="releaseDate" />
        <ReferenceArrayField source="imageBuilds" reference="cve/image-builds">
          <Datagrid bulkActionButtons={false}>
            <TextField source="name" />
          </Datagrid>
        </ReferenceArrayField>
        <TextField source="createdAt" />
        <TextField source="updatedAt" />
      </Tab>
      {/* <Tab label="CVEs">
        <ReferenceManyField reference="cve/tracked-cves" target="vulnerableRelease">
          <List>
            <Link
              to={`/tracked-cves?displayedFilters=${JSON.stringify({
                vulnerableRelease: true,
              })}&filter=${JSON.stringify({
                vulnerableRelease: useRecordContext()?.id,
              })}`}
              className="ra-link"
            >
              View CVEs
            </Link>
          </List>
        </ReferenceManyField>
      </Tab> */}
    </TabbedShowLayout>
  </Show>
);

export const ReleaseEdit = () => {
  return (
    <Edit redirect="show">
      <SimpleForm>
        <TextInput label="product" source="name" disabled />
        <TextInput source="version" disabled />
        <DateInput source="endOfMaintenanceDate" />
        <DateInput source="releaseDate" />
        <ReferenceArrayInput
          source="imageBuilds"
          reference="cve/image-builds"
        />
      </SimpleForm>
    </Edit>
  );
};

export const ReleaseCreate = () => {
  return (
    <Create redirect={"show"}>
      <SimpleForm>
        <TextInput label="Product" source="name" validate={[required()]} />
        <TextInput source="version" validate={[required()]} />
        <DateInput source="releaseDate" validate={[required()]} />
        <DateInput source="endOfMaintenanceDate" />
        <ReferenceArrayInput source="imageBuilds" reference="cve/image-builds">
          <AutocompleteArrayInput
            optionText="name"
            filterToQuery={(searchText) => ({
              q_name: searchText,
            })}
          />
        </ReferenceArrayInput>
      </SimpleForm>
    </Create>
  );
};
